<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12 offset-xs9>
        
        <v-btn color="info" @click="addNew" v-if="$can('do','POKO_Terapeuci_Edycja')">Dodaj urlop</v-btn>
      </v-flex>
      <v-flex xs12>
        <v-data-table              
              :options.sync="pagination"
              :items="items"
              :loading="loading"
              :server-items-length="totalResults"
              :footer-props="{itemsPerPageOptions:[20,50,100,200]}" 
              :headers="headers">
                 <template v-slot:item.start="{item}">
                    {{ getDateFormatted(item.start) }}
                 </template>
                 <template v-slot:item.end="{item}">
                    {{ getDateFormatted(item.end) }}
                 </template>                 
                 <template v-slot:item.type="{item}">
                    {{ getHolidayType(item.type) }}
                 </template>                                  
                 <template v-slot:item.id="{item}">
                    <v-layout align-center>
                      <v-icon small class="mr-2" @click="editHoliday(item.id)" v-if="$can('do','POKO_Terapeuci_Edycja')" title="Edytuj">fa-edit</v-icon>
                      <v-icon small class="mr-2"  @click="deleteHoliday(item.id)" v-if="$can('do','POKO_Terapeuci_Edycja')" title="Usuń">fa-trash-alt</v-icon>
                    </v-layout>
                 </template>                                           
        </v-data-table>    
        <HolidayEdit :visible="showAddHoliday" :holidayData="holidayData" :therapistID="therapistid" @close="closeAddPopup" />
      </v-flex>
    </v-layout>           
  </v-container>
</template>

<script>
import {  mapActions } from "vuex";
import { therapistsService } from "@/services/";
import swal from "sweetalert";
import HolidayEdit from "./HolidayEdit";
import * as dayjs from "dayjs";
export default {
  name: "Holidays",
  data() {
    return {   
      loading: true,
      showAddHoliday: false,
      holidayData: {
        id: 0,
        type: 0,
        start: '',
        end: ''
      },            
      totalResults: 0,
      items: [],      
      pagination: {},      
      headers: [
        { text: 'Początek', sortable: true, align: 'left', value: 'start'},
        { text: 'Koniec', sortable: true, align: 'left', value: 'end'} ,
        { text: 'Typ', sortable: false, align: 'left', value: 'type'},
        { text: 'Akcje', sortable: false, align: 'left', value: 'id'}        
      ]      
    }
  },
  props: ["therapistid"],
  components: { HolidayEdit},
  methods: {    
    ...mapActions("alert", ["error", "success"]),
    addNew() {
      this.holidayData.id = 0
      this.holidayData.type = 0
      this.holidayData.start = ''
      this.holidayData.end = ''
      this.showAddHoliday = true
    },
    getDateFormatted(date)
    {
       var dj = dayjs(date);
       return dj.format("DD/MM/YYYY");
    },
    getHolidayType(type)
    {
      switch(type)
      {
        case 0:
          return 'Wypoczynkowy';
        case 1:
          return 'Na żądanie';
        case 2:
          return 'Chorobowy';
      }
      return '';
    },
    editHoliday(id) {
      let b = this.items.find(x=>x.id == id)
      if(b != null)
      {
          this.holidayData.id = b.id
          this.holidayData.type = b.type
          this.holidayData.start = dayjs(b.start).format('YYYY-MM-DD')
          this.holidayData.end = dayjs(b.end).format('YYYY-MM-DD')
          this.showAddHoliday = true
      }      
      
    },
    deleteHoliday(id) {
      swal({
        title: "Czy na pewno?",
        text:
          "Czy na pewno chcesz usunąć ten urlop?",
        icon: "warning",
        buttons: ["Nie", "Tak"],
        dangerMode: true
      }).then(confirmed => {
        if (confirmed) {
          therapistsService
            .DeleteTherapistHoliday(id)
            .then(resp => {
              if (resp.data == null || !resp.data.success) {
                throw "Błąd usuwania urlopu";
              } else {
                this.success("Usunięto");
                this.refreshTable()
              }
            })
            .catch(e => {
              console.log(e);
              this.error("Nie można usunąć urlopu");
            });
        }
      });
    },
    closeAddPopup() {
      this.refreshTable()
      this.showAddHoliday = false
      this.selectedHolidayId = 0
    },
    
    refreshTable()
    {
          this.loading = true

          this.requestHolidays().then(data=> {
            this.items = data.data.result.items,
            this.totalResults = data.data.result.totalCount
            this.loading = false
          })    
    },
    requestHolidays() {   
      const { sortBy, sortDesc, page, itemsPerPage } = this.pagination
      let sortValue = ''
      if(sortBy.length > 0)
      {
        sortValue = sortBy[0]
        if(sortDesc.length > 0)
          sortValue = sortBy[0] + ( sortDesc[0] ? " DESC": "");
      }
      var req = therapistsService.getAllHolidays({ query: '', page: page, limit: itemsPerPage, sorting: sortValue, therapistid: this.therapistid });
      return req.catch(()=> {
        this.error("Błąd pobierania urlopów");
      });
    }
  },
  created() {    
  },
  beforeMount() {},
    watch: {
      pagination: {
        handler() {
          this.requestHolidays().then(data=> {
            this.items = data.data.result.items,
            this.totalResults = data.data.result.totalCount
            this.loading = false
          })    
        },
        deep: true
      }
    },  
};
</script>

<style>

</style>
